import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: '\'Inter\', sans-serif',
    body: '\'Inter\', sans-serif'
  },
  colors: {
    brand: {
      main: '#0086b8',
      secondary: '#666bb2',
      black: '#1d1d1b',
      softBlack: '#3c3c3c',
      darkGrey: '#878787',
      grey: '#ededed',
      mediumGrey: '#c6c6c6',
      pinkGrey: '#f2f2f2',
      softPinkGrey: '#f5f5f5',
      lightGrey: '#ececec',
      white: '#fff'
    },
    status: {
      success: '#009145', // green
      pending: '#ff9b01', // yellow
      error: '#ec1e27' // red
    }
  },
  components: {
    Button: {
      baseStyle: {
        _hover: {
          opacity: '90%'
        },
        _disabled: {
          _hover: {
            background: '#a3d0e3 !important'
          }
        },
        fontWeight: 600,
        fontFamily: 'Inter',
        lineHeight: 1
      },
      sizes: {
        xl: {
          h: '56px',
          fontSize: 'lg',
          px: '32px',
          lineHeight: 0
        },
        md: {
          h: '42px',
          fontSize: 'md',
          px: '20px',
          lineHeight: 0
        },
        sm: {
          h: '36px',
          fontSize: 'md',
          px: '26px',
          lineHeight: 0
        },
        xs: {
          h: '32px',
          fontSize: 'sm',
          px: '23px',
          lineHeight: 0
        }
      },
      variants: {
        primary: {
          bg: 'brand.main',
          color: 'brand.white'
        },
        secondary: {
          bg: 'brand.white',
          color: 'brand.main',
          border: '2px solid',
          borderColor: 'brand.main'
        }
      },
      defaultProps: {
        size: 'sm',
        variant: 'primary'
      }
    },
    Checkbox: {
      baseStyle: {
        control: {
          _checked: {
            bg: 'brand.main'
          },
          _focus: {
            boxShadow: 'none'
          }
        }
      },
      variants: {
        box: {
          control: {
            bg: 'brand.white',
            position: 'absolute',
            border: '2px',
            right: '5px',
            top: '5px',
            borderColor: 'brand.darkGrey'
          },
          label: {
            margin: 0
          }
        }
      }
    },
    Progress: {
      baseStyle: {
        filledTrack: {
          bg: '#0086b8'
        }
      }
    },
    Heading: {
      sizes: {
        xl: {
          fontSize: '36px'
        },
        md: {
          fontSize: '28px'
        },
        sm: {
          fontSize: '26px'
        }
      },
      variants: {
        primary: {
          color: 'brand.main'
        },
        secondary: {
          color: 'brand.black'
        }
      },
      defaultProps: {
        size: 'xl',
        variant: 'primary'
      }
    },
    Spinner: {
      sizes: {
        '3xl': {
          height: '110px',
          width: '110px'
        }
      }
    },
    Text: {
      sizes: {
        xl: {
          fontSize: '19px'
        },
        md: {
          fontSize: '17px'
        },
        sm: {
          fontSize: '15px'
        },
        ms: {
          fontSize: '14px'
        },
        xs: {
          fontSize: '13px',
          lineHeight: '16px'
        }
      },
      variants: {
        primary: {
          color: 'brand.black'
        },
        secondary: {
          color: 'brand.darkGrey'
        },
        tertiary: {
          color: 'brand.softBlack'
        },
        bold: {
          color: 'brand.black',
          fontWeight: 600,
          fontFamily: 'Inter'
        }
      },
      defaultProps: {
        size: 'md',
        variant: 'primary'
      }
    }
  }
})

export default theme
